<div class="example-container mat-elevation-z8 table-container">
  @if (tableIsLoading$ | async) {
    <mat-progress-bar mode="indeterminate" style="width:100%"></mat-progress-bar>
  }
  <table [dataSource]="dataSource" mat-table matSort matSortActive="ddtDate" matSortDirection="desc"
    matSortDisableClear style="width:100%">
    <ng-container matColumnDef="ddtNr">
      <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Delivery Note Nr.</th>
      <td *matCellDef="let row" mat-cell> {{ row.ddtNr }}</td>
    </ng-container>

    <ng-container matColumnDef="downloadUrl">
      <th *matHeaderCellDef i18n mat-header-cell>Document</th>
      <td *matCellDef="let row" mat-cell>
        @if (row.downloadUrl) {
          <span>
            <a [href]="row.downloadUrl" target="_blank">
              <mat-icon matListIcon>attach_file</mat-icon>
            </a>
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Description</th>
      <td *matCellDef="let row" mat-cell> {{ row.note }}</td>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Vendor</th>
      <td *matCellDef="let row" mat-cell>
        <div> {{ row.order.vendor?.name }}</div>
        @if (row.order.primaryContact?.emails) {
<a [href]="'https://mail.google.com/mail/u/0/?view=cm&fs=1&to='+ row.order.primaryContact.emails[0].email"
                   target="_blank">
          <span class="author-email">
            {{ row.order.primaryContact.name }}
          </span>
                    <span class="author-email">
              &#x3C;{{ row.order.primaryContact.emails[0].email }}&#x3E;
            </span>
                </a>
}
            </td>
        </ng-container>

        <ng-container matColumnDef="orderNr">
            <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Order Nr.</th>
            <td *matCellDef="let row" mat-cell> {{ row.order?.orderNr }}</td>
        </ng-container>

        <ng-container matColumnDef="ddtDate">
            <th *matHeaderCellDef i18n mat-header-cell mat-sort-header>Delivery Note Date</th>
            <td *matCellDef="let row" mat-cell> {{ row.ddtDate | date }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef i18n mat-header-cell>Actions</th>
            <td *matCellDef="let row" mat-cell>
                <a [routerLink]="['/ddt',row.id]" mat-icon-button>
                    <mat-icon>mode_edit</mat-icon>
                </a>
            </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </table>

    <mat-paginator [length]="totalElements"
                   [pageSizeOptions]="[10, 20, 50, 100, 500]"></mat-paginator>
</div>
